import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navOpen: this.props.active
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.active !== nextProps.active) {
            this.setState({navOpen: nextProps.active});
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideDropdownClick, false);
    }

    toggleNavHamburger = () => {
        this.props.toggleNav();
    }

    renderLogo = () => {
        return (
            <div>
                <img src="https://s3.amazonaws.com/bcs-media-dev/ui/bcs-logo-solid.svg" alt="BCS Docs Home"/>
            </div>
        )
    }

    render() {
        return (
            <header className={`bcs-header ${this.props.condenseNav ? 'expanded' : ''}`} data-component="header" ref={node => { this.node = node; }}>
                <div className="header-logo padding-t-2">
                    {this.state.sectionName !== '' ? (
                        <Link to="/" aria-label="Bootcamp Spot home page">{this.renderLogo()}</Link>
                    ) : (
                        this.renderLogo()
                    )}
                </div>
                <nav className="header-nav">
                </nav>
            </header>
        )
    }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js